import { Injectable } from '@angular/core';
import { PageStyle } from 'app/shared/models/page-style.model';
import { PageStyleService } from 'app/shared/services/page-style.service';

@Injectable()
/*@Component({
  selector: 'app-page-style-base',
  templateUrl: './page-style-base.component.html',
  styleUrls: ['./page-style-base.component.scss']
})*/

export abstract class PageStyleBaseComponent {

  pageStyle: PageStyle;
  logoImageUrl: string | null = undefined;
  backgroundImageUrl: string | null = undefined;

  headerStyle = {
    'background-color': '' // '##FFFFFF'
  };

  headingTextStyle = {
    'color': '' // '#007DB8'
  };

  bodyTextStyle = {
    'color': ''// '#007DB8'
  };

  buttonStyle = {
    'background-color': '#009DA0',
    'border-color': '#009DA0',
    'color': '#fff'
  };

  constructor(protected pageStyleService?: PageStyleService) {
  }

  initialize(authorizationCode: string, afterInitializeCallback?: Function): void {
    if (this.pageStyle == null) {
      this.pageStyle = new PageStyle();
    }

    if (this.pageStyleService) {
      this.pageStyleService.getObject<PageStyle>('/page-style/' + authorizationCode, null, (pageStyle) => {
        if (pageStyle != null) {
          this.pageStyle = pageStyle;
          afterInitializeCallback();
        }
      },
        true,
        false,
        true);

      this.pageStyleService.getLogoImage(authorizationCode, (logoImageUrl: string) => {
        this.logoImageUrl = logoImageUrl;
      });

      this.pageStyleService.getBackgroundImage(authorizationCode, (backgroundImageUrl: string) => {
        this.backgroundImageUrl = backgroundImageUrl;
      });
    }
  }

  // This method was added, as we don't have an authorization code when choosing an amount for a PaymentAction, yet we need the styling here already
  // Only after an amount is chosen and a PaymentRequest is made, we know what the authorization code is
  initializeViaPaymentActionId(paymentActionId: string, afterInitializeCallback?: Function): void {
    if (this.pageStyle == null) {
      this.pageStyle = new PageStyle();
    }

    if (this.pageStyleService) {
      this.pageStyleService.getObject<PageStyle>('/page-style/by-payment-action/' + paymentActionId, null, (pageStyle) => {
        if (pageStyle != null) {
          this.pageStyle = pageStyle;
          afterInitializeCallback();
        }
      },
        true,
        false,
        true);

      this.pageStyleService.getLogoImageByPaymentActionId(paymentActionId, (logoImageUrl: string) => {
        this.logoImageUrl = logoImageUrl;
      });

      this.pageStyleService.getBackgroundImageByPaymentActionId(paymentActionId, (backgroundImageUrl: string) => {
        this.backgroundImageUrl = backgroundImageUrl;
      });
    }
  }

  initializeStyles(): void {
    if (this.pageStyle.HeaderColor) {
      this.headerStyle['background-color'] = this.pageStyle.HeaderColor;
    }

    if (this.pageStyle.HeadingTextColor) {
      this.headingTextStyle.color = this.pageStyle.HeadingTextColor;
    }

    if (this.pageStyle.BodyTextColor) {
      this.bodyTextStyle.color = this.pageStyle.BodyTextColor;

    }

    if (this.pageStyle.ButtonColor) {
      this.buttonStyle['background-color'] = this.pageStyle.ButtonColor;
    }

    if (this.pageStyle.ButtonColor) {
      this.buttonStyle['border-color'] = this.pageStyle.ButtonColor;
    }
  }
}
